// © Microsoft Corporation. All rights reserved.

/**
 * Aad data formatted from browser response
 */
export type AadData = {
  /**
   * Access token
   */
  token: string;

  /**
   * Any error info
   */
  errorInfo: AadErrorInfo;

  /**
   * Flag to indicate if call was successful
   */
  isSuccess: boolean;

  /**
   * Flag to indicate if token is valid
   */
  isValid: boolean;
};

/**
 * Error info from aad request
 */
export type AadErrorInfo = {
  /**
   * Error string
   */
  error_string?: string;

  /**
   * Platform error code
   */
  platform_error_code?: number;

  /**
   * Primary error code
   */
  primary_error?: number;

  /**
   * Secondary error code
   */
  secondary_error?: number;
};

/**
 * The client id of our application
 */
export const clientId = "d7b530a4-7680-4c23-a8bf-c52c121d2e87";

/**
 * The scope/resource id for enterprise One Service
 */
export const oneServiceScope = "f920ab6b-8a48-4438-9255-1650179a3a0f";